// extracted by mini-css-extract-plugin
export var blue = "_o-f";
export var brand = "_o-b";
export var darkGrey = "_o-e";
export var disabled = "_o-4";
export var disabledSubtle = "_o-5";
export var error = "_o-6";
export var green = "_o-g";
export var grey = "_o-d";
export var icon = "_o-0";
export var inherit = "_o-a";
export var lightGrey = "_o-c";
export var orange = "_o-i";
export var pink = "_o-k";
export var primary = "_o-1";
export var purple = "_o-l";
export var red = "_o-j";
export var secondary = "_o-2";
export var success = "_o-9";
export var tertiary = "_o-3";
export var warning = "_o-7";
export var warningSecondary = "_o-8";
export var white = "_o-m";
export var yellow = "_o-h";